module.exports = __webpack_public_path__ + "img/47ne.99b21ff9.svg";